module.exports = __webpack_public_path__ + "img/UI_common_framelabelFX_02_26e244cc9.png";